module.exports = __webpack_public_path__ + "static/12-926c5f370064a0450675253b10802548.jpg";